import * as React from 'react';
import { flow, forEach } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../../../redux/IStore';
import PersonalDetailsForm from './PersonalDetailsForm';
import PersonalDetailsSummary from './PersonalDetailsSummary';
import { mtaActions } from '../../../../../../services/mta/actions';
import { IAuthState } from '../../../../../../services/auth/models';
import { IMtaActions, IMtaFormNames } from '../../../../../../services/mta/models';
import { IPolicy, ITraveller } from '../../../../../../data/api/models';
import { getFormValues } from 'redux-form';

interface IPersonalDetailProps {
  auth: IAuthState;
  activePolicies: IPolicy[];
  formValues: any;
  actions: {
    mta: IMtaActions;
  };
}

interface IPersonalDetailsState {
  showSummaryPage: boolean;
  disableButton: boolean;
  formValues: {
    travellers: any;
    policyId?: string;
  };
}

class PersonalDetails extends React.Component<IPersonalDetailProps, IPersonalDetailsState> {

  constructor(props) {
    super(props);

    this.state = {
      showSummaryPage: false,
      disableButton: false,
      formValues: {
        travellers: null,
        policyId: null,
      },
    };

    this.setTravellers();
  }

  private getSelectedPolicy = (): IPolicy => {
    const { activePolicies } = this.props;
    let selectedPolicy: IPolicy = null;
    forEach(activePolicies, (policySelected) => {
      if (location.pathname.match(policySelected.id)) {
        selectedPolicy = policySelected;
      }
    });

    return selectedPolicy;
  }

  private getTravellers = (): ITraveller[] => {
    const { formValues } = this.props;
    let travellers: ITraveller[];
    const selectedPolicy: IPolicy = this.getSelectedPolicy();

    // Keeping the changes if we come back from the summary page
    travellers = formValues && formValues.travellers &&
    formValues.travellers.length &&
    (formValues.policyId === selectedPolicy.id) ? formValues.travellers : selectedPolicy.travellers;

    return travellers;
  }

  private setTravellers = (): void => {
    let travellers: ITraveller[];
    let policyId: string;
    const selectedPolicy: IPolicy = this.getSelectedPolicy();

    // Keeping the changes if we come back from the summary page
    travellers = this.getTravellers();
    policyId = selectedPolicy.id;

    this.state = {
      showSummaryPage: false,
      disableButton: false,
      formValues: {
        travellers,
        policyId,
      },
    };

  }

  private handleSubmit = (values) => {
    if (values) {
      this.setState(() => {
        return {
          showSummaryPage: true,
        };
      });
    }
  }

  private handleBackButton = () => {
    this.setState(() => {
      return {
        showSummaryPage: false,
        formValues: {
          travellers: this.getTravellers(),
          policyId: this.getSelectedPolicy().id,
        },
      };
    });
  }

  private handleSubmitToApi = () => {
    this.setState({ disableButton: true });
    this.props.actions.mta.submitPersonalDetailsForm();
  }

  public render() {
    if (!this.state.showSummaryPage) {
      return (
        <div>
          <div className={'mt-15'}/>
          <PersonalDetailsForm
            initialValues={this.state.formValues}
            onSubmit={this.handleSubmit}/>
        </div>
      );
    } else {
      return (
        <div>
          <div className={'mt-15'}/>
          <PersonalDetailsSummary
            {...this.props}
            handleBackButton={this.handleBackButton}
            disableButton={this.state.disableButton}
            selectedPolicy={this.getSelectedPolicy()}
            handleSubmit={this.handleSubmitToApi}/>
        </div>
      );
    }
  }
}

export default flow([
  connect((state: IStore) => ({
      auth: state.auth,
      activePolicies: state.auth.customer.activePolicies,
      formValues: getFormValues(IMtaFormNames.PERSONAL_DETAILS)(state),
    }),
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      },
    }),
  ),
])(PersonalDetails);
